import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
  getFiduciary,
  getGoPeopleFiduciaire,
  getOrganizationSettings,
  getUaSettingByOrganisation,
} from "../api";
import {
  getCommunityFromCookie,
  transformFidToOrganization,
  getAuthInfosFromCookie,
} from "../utils";

import { unsetNavCommunity } from "./auth";

const initialState = {
  fetching: false,
  fetched: false,
  fiduciary: null,
  freeCycle: false,
};

export const fetchFiduciary = createAsyncThunk(
  "folder/fetchFiduciary",
  async (tmp, { getState, dispatch }) => {
    let { token, user, goPeopleOrganizationId } = getState().auth;
    if (!token) {
      return null;
    }
    if (!user) {
      await new Promise((r) => setTimeout(r, 1000));
      user = getState().auth.user;
    }

    try {
      const community = getCommunityFromCookie();
      const cookie = getAuthInfosFromCookie();
      let fiduciaire;
      if (cookie && cookie.goPeopleOrganizationId && cookie.jwtToken) {
        const responseGoApi = await getGoPeopleFiduciaire({
          jwtToken: cookie.jwtToken,
          communityId: tmp
            ? tmp
            : goPeopleOrganizationId
              ? goPeopleOrganizationId
              : cookie.goPeopleOrganizationId,
        });

        const fid = responseGoApi.data.data[0];

        const ttpOrganisationSettingsResponse = await getOrganizationSettings(
          token,
          fid?.ttp_organization_id ?? null
          //  fid?.organization_settings_id ?? null
        );
        const ttpUaSettingsResponse = await getUaSettingByOrganisation(
          token,
          fid?.ua_settings_id ?? null
        );

        fiduciaire = transformFidToOrganization(
          fid,
          ttpOrganisationSettingsResponse.data.data,
          ttpUaSettingsResponse.data.data
        );

        return fiduciaire;
      }

      const response = await getFiduciary({
        token,
        fiduciaryId: community ? community.id : null,
        user: user ?? null,
      });

      if (response.data.data.length === 1) {
        return response.data.data[0];
      } else {
        let folder = null;
        response.data.data.forEach((item) => {
          if (!folder || folder?.uaStatus !== "VALIDATED") {
            if (!folder) {
              folder = item;
            } else {
              if (item.uaStatus === "VALIDATED") {
                folder = item;
              } else if (
                item.uaStatus === "PENDING" &&
                folder.uaStatus === "CREATED"
              ) {
                folder = item;
              }
            }
          }
        });

        return folder;
      }
    } catch (e) {
      dispatch(unsetNavCommunity());
      return null;
    }
  }
);

const folderSlice = createSlice({
  name: "folder",
  initialState,
  reducers: {
    setFreeCycle: (state, { payload }) => {
      state.freeCycle = payload;
    },
    setFiduciary: (state, { payload }) => {
      state.fiduciary = payload;
    },
    setFolderFetched: (state, { payload }) => {
      state.fetched = payload;
    },
    setOnBoardingStep: (state, { payload }) => {
      if (state.fiduciary) {
        state.fiduciary.onBoardingStep = payload;
      }
    },
    setPortalSubDomain: (state, { payload }) => {
      if (state.fiduciary) {
        state.fiduciary.subdomain = payload;
      }
    },
    setHubPreferencesPortals: (state, { payload }) => {
      if (state.fiduciary) {
        if (state.fiduciary.hubPreferences) {
          state.fiduciary.hubPreferences = {
            ...state.fiduciary.hubPreferences,
            portals: payload,
          };
        } else {
          state.fiduciary.hubPreferences = { portals: payload };
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFiduciary.pending, (state, action) => {
      state.fetching = true;
      state.fetched = false;
    });
    builder.addCase(fetchFiduciary.fulfilled, (state, action) => {
      state.fetched = true;
      state.fetching = false;
      if (action.payload) {
        state.fiduciary = action.payload;
      } else {
        state.fiduciary = null;
      }
    });
    builder.addCase(fetchFiduciary.rejected, (state, action) => {
      state.fiduciary = null;
      state.fetched = true;
      state.fetching = false;
    });
  },
});
export const {
  setFreeCycle,
  setFiduciary,
  setFolderFetched,
  setOnBoardingStep,
  setPortalSubDomain,
  setHubPreferencesPortals,
} = folderSlice.actions;

export default folderSlice.reducer;
